import { useRecoilTask } from 'recoil-toolkit';

import { showNotificationTask } from './tasks';

export const useShowNotification = () => useRecoilTask(showNotificationTask, []);
